export default __webpack_public_path__ + "static/integration-illustration-7f4a8d1daed1e465c8012f2ccd3b3acb.svg";